import React from 'react';
import { useSelector } from 'react-redux';
import { OTHER_DISEASE } from 'utils/constants/disease';
import app from 'new-ui/app';
import { useTranslation } from 'utils/modifiedTranslation';
import { useProviderSpecificConfiguration } from 'modules/appConfiguration/useProviderSpecificConfiguration';
import { useMatchesFilterLocation } from 'modules/matchesFilter/MatchesFilterContext';
import { useSetHeaderSettings } from 'components/PageHeader/PageHeaderContext';
import { TAB_IDS, VERSIONS } from 'components/PageHeader/constants';
import AiAssistant from 'new-ui/Components/AiAssistent';
import { getUserCondition, isNewlyDiagnosedUser } from 'modules/user/utils';
import { StickyContainer } from 'new-ui/Components/StickyContainer';
import { TreatmentOptionsGuide } from 'new-ui/Components/TreatmentOptionsGuide';
import { useIsMobileResolution } from 'utils/hooks/useIsMobileResolution';
import { POPUP } from 'utils/constants/popup';
import { hasUserSponsoredTrials } from 'new-ui/functions';
import Nba from 'new-ui/NBA/Nba';
import { DISPLAY_CONTEXT } from 'new-ui/NBA/nba.constants';
import { Widgets } from './Widgets';
import { CustomerRefUserWidgets } from './CustomerRefUserWidgets';
import { FEED_GA } from './constants';
import './feed.css';

const openShareWithDoctorPopup = () => {
  app.openPopup(POPUP.SHARE_WITH_MY_DOCTOR);
};

const openCallUsPopup = () => {
  app.openPopup(POPUP.CALLUS, {
    CSS: {
      width: '600px',
    },
  });
};

const getStickyWidgetStyle = ({ isMobile }) => {
  const style = {
    paddingTop: isMobile ? '0px' : '44px',
    top: '-350px',
  };
  return style;
};

export const Feed = () => {
  const { t } = useTranslation();
  useMatchesFilterLocation();

  const user = useSelector((state) => state.profile.data);
  const { symptomCareDisabled } = useProviderSpecificConfiguration();
  const isMobileResolution = useIsMobileResolution();

  useSetHeaderSettings({
    version: VERSIONS.PATIENT_MAIN,
    tabIds: [
      TAB_IDS.FEED,
      TAB_IDS.TREATMENT_OPTIONS,
      TAB_IDS.SUPPORT_PROGRAMS,
      ...(symptomCareDisabled ? [] : [TAB_IDS.SYMPTOM_CARE]),
      ...(isNewlyDiagnosedUser(user) ? [TAB_IDS.ARTICLES] : []),
      TAB_IDS.SPEAK_WITH_TINA,
    ],
  });

  const welcome = `${t('feed.title.main')}${user.info.family_name ? `, ${user.info.family_name}!` : ''}`;

  const { personal: { customerRef } = {} } = user;
  const condition = getUserCondition(user);

  return (
    <div className="feed-page">
      <h2 className="welcome welcome-mobile">{welcome}</h2>
      <div className="feed-page-container">
        <h2 className="welcome">{welcome}</h2>
        {condition !== OTHER_DISEASE && (
          <div className="nba-on-feed-page-wrapper">
            <Nba displayContext={DISPLAY_CONTEXT.RETURNED_USER} />
          </div>
        )}
        {customerRef ? (
          <CustomerRefUserWidgets />
        ) : (
          <Widgets />
        )}
      </div>
      {condition !== OTHER_DISEASE && (
        <div className="feed-sidebar">
          <StickyContainer
            style={getStickyWidgetStyle({ isMobile: isMobileResolution })}
          >
            <TreatmentOptionsGuide
              onClickShare={openShareWithDoctorPopup}
              onClickTalk={openCallUsPopup}
              sponsoredUser={hasUserSponsoredTrials()}
            />
            <AiAssistant
              onUploadClick={() => {
                app.sendGoogleAnalyticsEvent(FEED_GA.category, FEED_GA.events.fileUploadClicked);
              }}
              onEditClick={() => {
                app.sendGoogleAnalyticsEvent(FEED_GA.category, FEED_GA.events.answerManuallyClicked);
              }}
            />
          </StickyContainer>
        </div>
      )}
    </div>
  );
};
